import { render, staticRenderFns } from "./VTableWrapper.vue?vue&type=template&id=d6c895f6&"
import script from "./VTableWrapper.vue?vue&type=script&lang=js&"
export * from "./VTableWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports